import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Status } from 'icreate/common/models/editor-viewer-element';
import { communicationTypes } from 'icreate/common/models/fu-unit';
import { getValidationErrors, mapErrors, ValidationErrorMap } from 'icreate/common/validators';
import { portNameLanMax } from 'icreate/common/validators/port/port-validator';

export enum PortInputName {
    commName = 'commName',
    LineIp = 'LineIp',
}

@Component({
    selector: 'app-port-dialog',
    templateUrl: './port-dialog.component.html',
    styleUrls: ['./port-dialog.component.css'],
    standalone: false,
})
export class PortDialogComponent {
    readonly COMM_NAME_MAX = portNameLanMax;

    readonly SERIAL = communicationTypes.serial;
    readonly LAN = communicationTypes.lan;

    readonly COMM_NAME = PortInputName.commName;
    readonly LINE_IP_ADDRESS = PortInputName.LineIp;

    validationErrors: ValidationErrorMap = {};

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: {
            title: string;
            use: Status;
            port: string;
            commName: string;
            commType: string;
            LineIp: string;
        },
        private dialogRef: MatDialogRef<PortDialogComponent>
    ) {}

    onInputChange(event: { name: string; value: string }) {
        const { name, value } = event;
        this.data[name] = value;

        this.checkInputErrors();
    }

    save() {
        this.dialogRef.close({
            use: this.data.use,
            port: this.data.port,
            commName: this.data.commName,
            commType: this.data.commType,
            LineIp: this.data.LineIp,
        });
    }

    close() {
        this.dialogRef.close(false);
    }

    checkInputErrors() {
        // const errors = getValidationErrors(portValidator(), {
        //     port: this.data.port,
        //     commName: this.data.commName,
        //     commType: this.data.commType,
        //     LineIp: this.data.LineIp,
        //     use: 1,
        // });
        // this.validationErrors = mapErrors(errors);
    }

    disabledSaveButton() {
        return !!Object.keys(this.validationErrors).length;
    }
}
